import React, { useState, useEffect } from 'react'
import slaRepository from '../SlaRepository'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { secondsToStringTimer } from '../../../utils/Formatter'
import { Typography, Tooltip, IconButton } from '@material-ui/core'
import statusSolicitacoesRepository from '../StatusSolicitacoesRepository'
import useQueryFilter from '../useQueryFilter'
import {
  FonteLiberacaoEnum,
  FonteLiberacaoLabelEnum,
  StatusEnum,
  StatusEnumAbrev
} from '../../Solicitacoes/components'
import { downloadCsv } from '../../../utils/DownloadCsv'

const useStyles = makeStyles(theme => ({
  pd: {
    padding: theme.spacing(2),
    paddingBottom: 0
  },
  parent: {
    marginTop: theme.spacing(1),
    overflowY: 'auto',
    transform: 'rotateX(180deg)'
  },
  child: {
    transform: 'rotateX(180deg)'
  },
  noWrap: {
    whiteSpace: 'nowrap'
  }
}))

export default function TableSolicitacaoAnalista(props) {
  const classes = useStyles()
  const [tableData, setTableData] = useState([])
  const [statusData, setStatusData] = useState([])
  const [fontesLiberacaoData, setFonteLiberacaoData] = useState([])

  const buildTable = (
    solicitacoesAnalista,
    temposAnalistas,
    metasAnalista,
    temposOciosos,
    fontesLiberacao,
    statusFinal
  ) => {
    const table = []
    Object.keys(solicitacoesAnalista).forEach(analistaId => {
      const porAnalista = solicitacoesAnalista[analistaId]

      const countByFonteLiberacao = []
      fontesLiberacao.forEach(fonteLiberacao => {
        const existFonteLiberacao =
          porAnalista.groupedByFonteLiberacao[fonteLiberacao]
        if (existFonteLiberacao?.[0]) {
          countByFonteLiberacao[fonteLiberacao] = parseInt(
            existFonteLiberacao[0].count
          )
        } else {
          countByFonteLiberacao[fonteLiberacao] = 0
        }
      })
      const countByStatus = {}
      statusFinal.forEach(status => {
        const existStatus = porAnalista.groupedByStatus[status]
        if (existStatus?.[0]) {
          countByStatus[status] = parseInt(existStatus[0].count)
        } else {
          countByStatus[status] = 0
        }
      })

      const countByFontesLiberacaoValues = Object.values(countByFonteLiberacao)
      const countByStatusValues = Object.values(countByStatus)

      const totalSolicitacoes = [
        ...countByFontesLiberacaoValues,
        ...countByStatusValues
      ].reduce((a, b) => a + b, 0)

      table.push({
        analistaId: analistaId,
        analista: porAnalista.analista,
        tempoOcioso:
          !!temposOciosos[analistaId] &&
          secondsToStringTimer(temposOciosos[analistaId].tempoAcumulado),
        tempoMaximo:
          !!temposAnalistas[analistaId] &&
          secondsToStringTimer(temposAnalistas[analistaId].tempomaximo),
        tempoMedio:
          !!temposAnalistas[analistaId] &&
          secondsToStringTimer(temposAnalistas[analistaId].tempomedio),
        totalSolicitacoes,
        metaSolicitacoes:
          metasAnalista[analistaId] &&
          metasAnalista[analistaId].metasolicitacoes,
        ...countByFonteLiberacao,
        ...countByStatus
      })
    })
    setTableData(table)
  }

  const [query, periodo] = useQueryFilter(props.location.search)
  useEffect(() => {
    async function fetchData(query) {
      if (query.dataInicio && query.dataFim) {
        const [
          responseTempoPorAnalista,
          responseSolicitacoesPorAnalista,
          responseMetasSolicitacoesPorAnalista,
          responseTemposOciosos,
          responseStatusFinal,
          responseFontesLiberacao
        ] = await Promise.all([
          slaRepository.tempoPorAnalista(
            query.dataInicio,
            query.dataFim,
            query.empresaId
          ),
          slaRepository.solicitacoesPorAnalista(
            query.dataInicio,
            query.dataFim,
            query.empresaId
          ),
          slaRepository.metasSolicitacoesPorAnalista(
            query.dataInicio,
            query.dataFim
          ),
          slaRepository.findTemposOciosos(query.dataInicio, query.dataFim),
          statusSolicitacoesRepository.getStatusFinais(),
          statusSolicitacoesRepository.getFontesLiberacao()
        ])

        if (
          responseTempoPorAnalista.ok &&
          responseSolicitacoesPorAnalista.ok &&
          responseMetasSolicitacoesPorAnalista.ok &&
          responseTemposOciosos.ok &&
          responseStatusFinal.ok &&
          responseFontesLiberacao.ok
        ) {
          const solicitacoesAnalista = responseSolicitacoesPorAnalista.data

          const metasAnalista = responseMetasSolicitacoesPorAnalista.data

          const toKeyValuePair = (data, key) =>
            data.reduce((a, b) => {
              a[b[key]] = b
              return a
            }, {})

          const temposAnalistas = toKeyValuePair(
            responseTempoPorAnalista.data,
            'analistaid'
          )
          const temposOciosos = toKeyValuePair(
            responseTemposOciosos.data,
            'analistaId'
          )

          const fontesLiberacaoNotAllowed = [FonteLiberacaoEnum.AUTOMATICAMENTE]

          const fontesLiberacaoArray = responseFontesLiberacao.data.filter(
            item => !fontesLiberacaoNotAllowed.includes(item)
          )

          setFonteLiberacaoData(fontesLiberacaoArray)

          const statusNotAllowed = [
            StatusEnum.LIBERADA,
            StatusEnum.LIBERADAGESTOR,
            StatusEnum.LIBERADACOMPENDENCIA,
            StatusEnum.LIBERADAAUTOMATICAMENTE,
            StatusEnum.NAORECOMENDADA
          ]

          const statusArray = responseStatusFinal.data.filter(
            item => !statusNotAllowed.includes(item)
          )

          setStatusData(statusArray)
          buildTable(
            solicitacoesAnalista,
            temposAnalistas,
            metasAnalista,
            temposOciosos,
            fontesLiberacaoArray,
            statusArray
          )
        }
      }
    }
    fetchData(query)
  }, [query])

  const onDownloadClick = async () => {
    await downloadCsv(
      tableData,
      { fields: [] },
      true,
      true,
      'Solicitações Analista'
    )
  }

  return (
    <Grid item sm={12}>
      <Paper>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item sm={11}>
            <Typography variant="h6" className={classes.pd}>
              Solicitações finalizadas por analista
            </Typography>
            <Typography variant="caption" className={classes.pd}>
              {periodo}
            </Typography>
          </Grid>
          <Grid item sm={1}>
            <Grid container direction="row" justifyContent="center">
              {tableData.length > 0 && (
                <Tooltip title="Baixar lista" aria-label="Baixar lista">
                  <IconButton size="small" onClick={onDownloadClick}>
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Typography variant="caption" className={classes.pd}>
          Considerando somente solicitações onde não houve troca de responsável
        </Typography>
        <div className={classes.parent}>
          <Table className={classes.child}>
            <TableHead>
              <TableRow>
                <TableCell align="center">Analista</TableCell>
                {[...fontesLiberacaoData, ...statusData].map(item => {
                  const label =
                    FonteLiberacaoLabelEnum[item] || StatusEnumAbrev[item]

                  return (
                    <Tooltip key={label} title={label}>
                      <TableCell align="center">{label}</TableCell>
                    </Tooltip>
                  )
                })}
                <TableCell align="center">Total de Solicitações</TableCell>
                <TableCell align="center">Meta de Solicitações</TableCell>
                <TableCell align="center">Tempo Ocioso</TableCell>
                <TableCell align="center">
                  <span className={classes.noWrap}>Tempo Máximo</span> Análise
                </TableCell>
                <TableCell align="center">
                  <span className={classes.noWrap}>Tempo Médio</span> Análise
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map(row => (
                <TableRow key={row.analistaId}>
                  <TableCell align="center">{row.analista}</TableCell>
                  {[...fontesLiberacaoData, ...statusData].map(item => (
                    <TableCell key={item} align="center">
                      {row[item]}
                    </TableCell>
                  ))}
                  <TableCell align="center">{row.totalSolicitacoes}</TableCell>
                  <TableCell align="center">{row.metaSolicitacoes}</TableCell>
                  <TableCell align="center">{row.tempoOcioso}</TableCell>
                  <TableCell align="center">{row.tempoMaximo}</TableCell>
                  <TableCell align="center">{row.tempoMedio}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Paper>
    </Grid>
  )
}
